import React, { useEffect, useState } from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImageWebpAuto } from '@ifeng-fe/public_method';
import { newApi } from '@src/utils';
import { jumpPageUrl, getQuery } from '@src/utils';
import { volcengineAndH5Statistics } from '@ifeng-fe/mobile_statistics';
import { type Post } from '@src/services/interface';

type VotePersonProps = {
    content: {
        vote?: Post['vote'];
        userId?: string;
    };
};

type PersonTS = {
    face: string;
    nickName: string;
    selectTitle: string;
};

const VotePerson = ({ content }: VotePersonProps) => {
    const [isShow, setIsShow] = useState<boolean>(true);
    const [personInfo, setPersonInfo] = useState<PersonTS>({
        face: '',
        nickName: '',
        selectTitle: '',
    });
    const voteId = content?.vote?.id;
    const userId = content?.userId || '';

    useEffect(() => {
        const getVoteInfo = async () => {
            if (userId && voteId) {
                try {
                    const result = await newApi.api.wordthingUserSurveyDetail(voteId, userId, {
                        baseUrl: 'https://shankapi.ifeng.com/',
                    });
                    const resultData = result?.data?.data;
                    const resFace = resultData?.userimg;
                    const resNickName = resultData?.nickname;
                    const resSelectTitle = resultData?.result?.[0]?.title;

                    if (resFace && resNickName && resSelectTitle) {
                        setPersonInfo({
                            face: resFace,
                            nickName: resNickName,
                            selectTitle: resSelectTitle,
                        });
                    } else {
                        setIsShow(false);
                    }
                } catch (e) {
                    setIsShow(false);
                    console.error(e);
                }
            } else {
                setIsShow(false);
            }
        };

        getVoteInfo();
    }, [userId, voteId]);

    const jumpHandle = () => {
        const userIdUrl = getQuery(window.location.href, 'userId') || '';

        volcengineAndH5Statistics({
            behavior: 'action',
            type: 'sharepage_link_button',
            button_name: 'a',
            user_id: userIdUrl,
        });
        jumpPageUrl('personal', userId);
    };

    return isShow ? (
        <div className={styles.votePerson}>
            <div className={styles.head} onClick={jumpHandle}>
                {personInfo.face && <img className={styles.face} src={formatImageWebpAuto(personInfo.face, 60, 60)} />}
                {personInfo.nickName && <div className={styles.username}>{personInfo.nickName}</div>}
            </div>
            {personInfo.selectTitle && <div className={styles.voteValue}>选择了“{personInfo.selectTitle}”</div>}
        </div>
    ) : null;
};

export default errorBoundary(VotePerson);
